/* GASSISA
=========================================================================================
* Descripcion: Version portatil del formulario ticket master.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
* ---------------------------------------------------------------------------------------
*/

import FrmParametrosCajaFormMaster from "../../configuracion/FrmParametrosCajaFormMaster.jsx";
import SizeSoftXFrmPortatil from "../leyout/SizeSoftXFrmPortatil.jsx";

export default function FrmParametrosCajaFormMasterPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmParametrosCajaFormMaster">
      <FrmParametrosCajaFormMaster />
    </SizeSoftXFrmPortatil>
  );
}
